import PropTypes from 'prop-types'
import React, { memo, useCallback } from 'react'
import TextField from '../../../../../../components/TextField'

const toNumberOrEmpty = (raw) => {
  if (raw === '' || raw === null || raw === undefined) {
    return null
  }

  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : null
}

function PolicyNumberField({ id, onChange, values = null, errors = [] }) {
  const handleChange = useCallback(
    (event) => {
      onChange(toNumberOrEmpty(event?.target?.value))
    },
    [onChange],
  )

  return (
    <TextField
      id={id}
      type="number"
      step={1}
      inputMode="numeric"
      value={values ?? ''}
      onChange={handleChange}
      errors={errors}
      disablePasswordManager
      containerClassName="mb-0"
    />
  )
}

PolicyNumberField.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.number,
  errors: PropTypes.arrayOf(PropTypes.string),
}

export default memo(PolicyNumberField)
